import { useLanguage } from "context/LanguageContext";

function maskAadhaar(val) {
    if (!val || val === "-") return "-";
    const digits = val.replace(/\s+/g, "");
    if (/^\d{12}$/.test(digits)) {
        return `XXXX XXXX ${digits.slice(8)}`;
    }
    return "XXXX XXXX XXXX";
}

function formatDate(val) {
    if (!val || val === "-") return "-";
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) return val;
    const d = new Date(val);
    if (isNaN(d)) return val;
    return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
}

function ClaimViewModal({ claim, onClose }) {
    const { t } = useLanguage();
    if (!claim) return null;

    const loan = claim.loan || {};
    const claimData = claim.claim || {};
    const claimTypeLabel = claim.claimType === "Disease" ? t.diseaseClaimType : t.deathClaimType;

    const KNOWN_TYPE_LABELS = {
        1: t.medicalCertificate,
        3: t.dobProof,
        6: t.dodProof,
    };

    const labeledAttachments = (claim.attachments || []).map(a => {
        const knownLabel = KNOWN_TYPE_LABELS[Number(a.type)];
        if (knownLabel) return { ...a, displayLabel: knownLabel };
        if (Number(a.type) === 8) {
            if (/id_proof/i.test(a.fileName || "")) return { ...a, displayLabel: a.label || t.uploadIdProofDoc };
            if (/other_document/i.test(a.fileName || "")) return { ...a, displayLabel: a.label || t.anotherDocument };
        }
        return { ...a, displayLabel: a.label || a.fileName };
    });

    return (
        <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: "#eaf4f0" }}>
                        <h5 className="modal-title" style={{ color: "#1a5c4a", fontWeight: "700" }}>
                            {claimTypeLabel} {t.claim} — {claim.id}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {/* Loan Details */}
                        <h6 style={{ color: "#1a5c4a", fontWeight: "700" }} className="mb-2">{t.loanDetails}</h6>
                        <div className="list-type mb-4">
                            <div className="row">
                                <div className="col-md-3 mb-2">
                                    <p className="mb-0 text-muted small">{t.loaneeFullName}</p>
                                    <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{loan.name}</h4>
                                </div>
                                <div className="col-md-3 mb-2">
                                    <p className="mb-0 text-muted small">{t.aadhaarNumber}</p>
                                    <h4 style={{ wordBreak: "break-all", fontSize: "0.85rem" }}>{maskAadhaar(loan.aadhaar)}</h4>
                                </div>
                                <div className="col-md-3 mb-2">
                                    <p className="mb-0 text-muted small">{t.mobileNumber}</p>
                                    <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{loan.mobile}</h4>
                                </div>
                                <div className="col-md-3 mb-2">
                                    <p className="mb-0 text-muted small">{t.loanNumber}</p>
                                    <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{loan.loanNo}</h4>
                                </div>
                                <div className="col-md-3 mb-2">
                                    <p className="mb-0 text-muted small">{t.loanAmount}</p>
                                    <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{loan.amount}</h4>
                                </div>
                                <div className="col-md-3 mb-2">
                                    <p className="mb-0 text-muted small">{t.societyMembership}</p>
                                    <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{loan.membership}</h4>
                                </div>
                                <div className="col-md-3 mb-2">
                                    <p className="mb-0 text-muted small">{t.societyName}</p>
                                    <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{loan.society}</h4>
                                </div>
                                <div className="col-md-3 mb-2">
                                    <p className="mb-0 text-muted small">{t.societyAddress}</p>
                                    <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{loan.societyAddress}</h4>
                                </div>
                                <div className="col-md-3 mb-2">
                                    <p className="mb-0 text-muted small">{t.dateOfBirth}</p>
                                    <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{loan.dob}</h4>
                                </div>
                                <div className="col-md-3 mb-2">
                                    <p className="mb-0 text-muted small">{t.birthCertificate}</p>
                                    <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{loan.birthCertificateNumber}</h4>
                                </div>
                            </div>
                        </div>

                        {/* Claim Details */}
                        <h6 style={{ color: "#1a5c4a", fontWeight: "700" }} className="mb-2">{claimTypeLabel} {t.claimDetails}</h6>
                        <div className="list-type mb-4">
                            <div className="row">
                                {claim.claimType === "Disease" ? (
                                    <>
                                        <div className="col-md-3 mb-2">
                                            <p className="mb-0 text-muted small">{t.diseaseCategory}</p>
                                            <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{claimData.diseaseCategoryName || "-"}</h4>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <p className="mb-0 text-muted small">{t.dateOfIllness}</p>
                                            <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{formatDate(claimData.dateOfIllness)}</h4>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <p className="mb-0 text-muted small">{t.hospitalCategory}</p>
                                            <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{claimData.hospitalCategoryName}</h4>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <p className="mb-0 text-muted small">{t.medicalCertIssuedBy}</p>
                                            <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{claimData.medicalCertificateIssuedBy}</h4>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <p className="mb-0 text-muted small">{t.medicalCertDate}</p>
                                            <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{formatDate(claimData.dateOfMedicalCertificate)}</h4>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="col-md-3 mb-2">
                                            <p className="mb-0 text-muted small">{t.claimantName}</p>
                                            <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{claimData.claimantName}</h4>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <p className="mb-0 text-muted small">{t.relationshipToLoanee}</p>
                                            <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{claimData.relationshipName}</h4>
                                        </div>
                                        {claimData.relationshipName === "Other" && (
                                            <div className="col-md-3 mb-2">
                                                <p className="mb-0 text-muted small">{t.specifyRelationship}</p>
                                                <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{claimData.otherRelationship}</h4>
                                            </div>
                                        )}
                                        <div className="col-md-3 mb-2">
                                            <p className="mb-0 text-muted small">{t.dateOfDeath}</p>
                                            <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{formatDate(claimData.dateOfDeath)}</h4>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <p className="mb-0 text-muted small">{t.deathCertificate}</p>
                                            <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{claimData.deathCertNumber}</h4>
                                        </div>
                                        <div className="col-md-3 mb-2">
                                            <p className="mb-0 text-muted small">{t.prevDiseaseRelief}</p>
                                            <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{claimData.previousDiseaseRelief}</h4>
                                        </div>
                                        {claimData.previousDiseaseRelief === "yes" && (
                                            <div className="col-md-3 mb-2">
                                                <p className="mb-0 text-muted small">{t.releaseAmount}</p>
                                                <h4 className="mb-0" style={{ fontSize: "0.95rem", fontWeight: "600", marginTop: "0", marginBottom: "0" }}>{claimData.releaseAmount}</h4>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Attachments */}
                        {labeledAttachments.length > 0 && (
                            <>
                                <h6 style={{ color: "#1a5c4a", fontWeight: "700" }} className="mb-2">{t.uploadedDocuments}</h6>
                                <div className="list-type mb-4">
                                    <div className="row">
                                        {labeledAttachments.map((a, i) => (
                                            <div key={i} className="col-md-4 mb-2">
                                                <p className="mb-0 text-muted small">{a.displayLabel}</p>
                                                <a href={a.url} target="_blank" rel="noopener noreferrer" style={{ color: "#1a5c4a", fontSize: "0.9rem" }}>
                                                    <i className="fa fa-file me-1"></i> {t.viewDoc}
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ClaimViewModal;
